/**
 * Bloquea el contenido principal si la ruta pertenece a un módulo desactivado en licencia/config.
 * POS-UX-CONTROL-RECOVERY-001: módulo bloqueado → AccessDenied (NO Dashboard).
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getRequiredModuleForPath } from '../../config/modulesCatalog';
import { isSuperAdminEmail } from '../../config/superAdmin';
import AccessDenied from './AccessDenied';

export default function ModuleOutletGuard({ children }) {
  const location = useLocation();
  const { currentUser, companyModules, loading } = useAuth();
  const required = getRequiredModuleForPath(location.pathname);

  if (loading) {
    return children;
  }

  if (isSuperAdminEmail(currentUser?.email)) {
    return children;
  }

  if (!required) {
    return children;
  }

  const enabled = companyModules?.[required] !== false;
  if (enabled) {
    return children;
  }

  return (
    <AccessDenied
      title="Módulo no disponible"
      message="Esta función no está incluida en el plan o está desactivada para tu empresa."
      detail={`Módulo: ${required}`}
      backTo="/"
    />
  );
}
